enum TopSpeakerActionTypes {
	CREATE_TOP_SPEAKER = "CREATE_TOP_SPEAKER",
	GET_TOP_SPEAKER = "GET_TOP_SPEAKER",
	GET_ALL_TOP_SPEAKERS = "GET_ALL_TOP_SPEAKERS",
	SET_TOP_SPEAKER_ID = "SET_TOP_SPEAKER_ID",
	SET_TOP_SPEAKER_ERROR = "SET_TOP_SPEAKER_ERROR",
	GET_DELETED_TOP_SPEAKERS = "GET_DELETED_TOP_SPEAKERS",
	UPDATE_TOP_SPEAKER = "UPDATE_TOP_SPEAKER",
	DELETE_TOP_SPEAKER = "DELETE_TOP_SPEAKER",
}

export default TopSpeakerActionTypes;
